import { Injectable } from '@angular/core';
import type { NonNullableFormBuilder } from '@angular/forms';
import type { Option } from '@comparit/core';
import { map, startWith } from 'rxjs';
import type { Laufzeit, Step2FormInput, Zahlungsweise } from '../../interfaces';
import { BaseForm } from '../base-form';
import { Step2Form } from './modules/step2-form';
import { laufzeitOptions } from './options/laufzeit-options';
import { zahlungsweiseOptions } from './options/zahlungsweise-options';

export interface VertragsdatenStepForms {
  step2: Step2FormInput;
}

@Injectable({ providedIn: 'root' })
export class VertragsdatenFormService {
  readonly laufzeitOptions: Option<Laufzeit>[] = laufzeitOptions;
  readonly zahlungsweiseOptions: Option<Zahlungsweise>[] = zahlungsweiseOptions;
}

export class VertragsdatenFormCreator extends BaseForm {
  constructor(
    private fb: NonNullableFormBuilder,
    private defaultValue?: VertragsdatenStepForms | null
  ) {
    super();
  }

  public step2Form = new Step2Form(this.fb, this.defaultValue?.step2);

  override stepsCtrls = {
    step2: this.step2Form.fg,
  };

  _fg = this.fb.group(this.stepsCtrls);
  fgDefaultValue = this._fg.getRawValue();

  fgValueChanges$ = this._fg.valueChanges.pipe(
    map(() => this._fg.getRawValue() as VertragsdatenStepForms)
  );

  fgValue$ = this._fg.valueChanges.pipe(
    startWith(null),
    map(() => this._fg.getRawValue() as VertragsdatenStepForms)
  );
}
